/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Channelreplysend2Inputs */

const en_channelreplysend2 = /** @type {(inputs: Channelreplysend2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reply`)
};

const de_channelreplysend2 = /** @type {(inputs: Channelreplysend2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antworten`)
};

/**
* | output |
* | --- |
* | "Reply" |
*
* @param {Channelreplysend2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const channelreplysend2 = /** @type {((inputs?: Channelreplysend2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Channelreplysend2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_channelreplysend2(inputs)
	return de_channelreplysend2(inputs)
});
export { channelreplysend2 as "channelReplySend" }